import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: `${process.env.PRIMARYCOLOR}`,
        secondary: "#00c1f3",
        accent: "#7986CB",
        error: "#f44336",
        warning: "#44d9ff",
        info: "#2196f3",
        success: "#4caf50"
      }
    }
  }
});
